import { render, staticRenderFns } from "./product-matching-listing.vue?vue&type=template&id=c65b1738&scoped=true&"
import script from "./product-matching-listing.vue?vue&type=script&lang=js&"
export * from "./product-matching-listing.vue?vue&type=script&lang=js&"
import style0 from "./product-matching-listing.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./product-matching-listing.vue?vue&type=style&index=1&id=c65b1738&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65b1738",
  null
  
)

export default component.exports